{{#COMPARE type '==' 'MBR'}}
	{{#if isLongRegister}}
		<div class="row m-b-15">
			<div class="col-sm-8 col-sm-offset-2">
				<div class="row">
					<div class="col-sm-11">
						<input id="js-value-input-long" class="form-control full-width"
							type="number" name="long_value" value="{{longValue}}"/>
					</div>
					<div class="col-sm-1 m-t-10">
						{{unit}}
					</div>
				</div>
			</div>
		</div>
		{{#if showExtendedInfos}}
			<div class="row">
				<div class="col-xs-12 m-t-5">
					{{TR "Rohwerte"}}
				</div>
			</div>
			<div class="row m-b-15 js-deny">
			{{#each registers}}
				<div class="col-sm-{{col}} m-b-10">
					<input id="js-value-reg-{{index}}" tabindex="-1" readonly="readonly"
						class="form-control full-width js-deny"
						type="number" name="value" value="{{raw}}">
				</div>
			{{/each}}
		</div>
		{{/if}}
	{{else}}
		<div class="row">
			<div class="col-xs-2">
				<button type="button" id="js-minus" class="btn btn-white m-t-20">
					<i class="fa fa-minus"></i>
				</button>
			</div>
			<div class="col-xs-8">
				<div class="slider slider-primary m-t-15 m-b-15">
					<input type="text" id="js-slider" data-plugin="range-slider"
						data-slider-orientation="horizontal"
						data-slider-min="{{min}}" data-slider-max="{{max}}"
						data-slider-value="{{raw}}">
				</div>
			</div>
			<div class="col-xs-2">
				<button type="button" id="js-plus" class="btn btn-white pull-right m-t-20">
					<i class="fa fa-plus"></i>
				</button>
			</div>
		</div>
		<div class="row m-b-15">
			<div class="col-sm-4 col-sm-offset-4">
				<input id="js-value-input" class="form-control full-width"
				type="number" min="{{min}}" max="{{max}}" name="value" value="{{raw}}">
			</div>
		</div>
	{{/if}}
{{else}}
	<div class="form-group">
		<label for="coil_select-input" class="control-label">{{TR "Coil-Zustand"}}</label>
		<select class="form-control" id="coil_select-input" name="coil_select">
			<option value="1" {{#COMPARE raw 1}}selected="selected"{{/COMPARE}}>
				{{DISPLAY_VALUE_PLAIN model 1}}
			</option>
			<option value="0" {{#COMPARE raw 0}}selected="selected"{{/COMPARE}}>
				{{DISPLAY_VALUE_PLAIN model 0}}
			</option>
		</select>
	</div>
{{/COMPARE}}
